<ng-container>
  <front-header [content]="'Post'" />

  <div class="post-container">
    <div
      [contentFlex]="'content'"
      [row]="'tablet'"
    >
      <div
        [contentFlex]="'content'"
        [col]="'12|3-tablet'"
      >
        <post-filter />
      </div>

      <div
        [contentFlex]="'content'"
        [col]="'12|9-tablet'"
        [row]="'tablet'"
        [wrap]="true"
      >
        @for (post of posts(); track post.slug) {
          <div
            [contentFlex]="'content'"
            [col]="'12|6-tablet|4-computer'"
            [grow]="0"
            [colPerRows]="3"
          >
            <post-card [post]="post" />
          </div>
        }
      </div>
    </div>
  </div>
</ng-container>
